export default {
    PersonalCenter:'PersonalCenter',
    MemberManage:'MemberManage',
    MemberGroupManage:'MemberGroupManage',
    RightsManage:'RightsManage',
    WorkBench: 'Workbench',
    TaskHall: 'Task hall',
    project:'Project',
    SystemSettings:'System Settings',
    teamInfo:'Team Info',
    authority:'Authority management',
    bankCardAccount:'Bank card account',
    mailingAddress:'Mailing Address',
    DoingTask: 'Doing tasks',
    Team: 'Team',
    Financ: 'Financ',
    Riskloan: 'Risk loan',
    ClueTask: 'Clue task',
    PublicTask: 'public task',
    DesignateTask: 'designate task',
    CaseTask: 'Case task',
    PublicCase: 'public case',
    DesignateCase: 'designate case',
    Clue: 'Clue',
    Case:'Case',
    MyTask: 'My task',
    AllTask: 'All task',
    MyResult: 'My clue',
    AllResult: 'All clue',
    MyCase: 'My case',
    Inprogress: 'In progress',
    Ended: 'Ended',
    AllCases: 'All case',
    CivilCase:'Civil Case',
    AdministrativeCase:'Administrative Case',
    CriminalCase:'Criminal Case',
    MaterialList:'Material List',
    AwaitAllocationCase: 'Await Allocation Case',
    MyTransactionCase: 'My Transaction Case',
    Processing: 'Processing',
    Transacted: 'Transacted',
    AllTransactionCase: 'All Transaction Case',
    TeamManagement: 'Team management',
    JobPermissions: 'Job Permissions',
    MyCenter: 'My center',
    ResetPwd: 'Reset pwd',
    Exit: 'Exit',
    Name:'Name',
    Sex:'Sex',
    Duties:'Duties',
    Account:'Account',
    Mail:'Mail',
    Mobile:'Mobile',
    Operating:'Operating',
    AddEmployee:'Add employee',
    editIcon:'edit',
    prohibitIcon:'prohibit',
    resetIcon:'reset password',
    enableIcon:'enable',
    'name/account/tel':'name / account / mobile',
    property:{
        "E":"Legal Representative",
        "I":"operator"
    },
    isEnable:{
        'Y':'Enable',
        'N':'Disabled'
    },
    cancel:'cancel',
    reset:'reset',
    sure:'sure',
    forbidUserModal:'Are you sure to disable the user?',
    resetModal:'Are you sure to reset password the user?',
    enableModal:'Are you sure to enable users ?',
    BatchEnableList:{
        'Y':'Batch operation',
        'N':'Batch disabled'
    },
    role:{
        'All':'All'
    },
    lawyerList:{
        'lawyer':'lawyer',
        'not-lawyer':'NonLawyer'
    },
    'identity-information':'Identity Information',
    certificateType:{
        'IC':'Identity Card',
        'PP':'Passport'
    },
    'ID-type':'ID Type'
  }


// WEBPACK FOOTER //
// ./src/locale/lang/en-US.js